export const clamp = (value, min, max) => {
	if (value < min){
		return min
	} else if (value > max){
		return max
	} else {
		return value
	}
}



// WEBPACK FOOTER //
// ./dev/utils/quantity.js